import { render, staticRenderFns } from "./BasicInfo.template.vue?vue&type=template&id=75649dfe&scoped=true&"
var script = {}
import style0 from "./BasicInfo.template.vue?vue&type=style&index=0&id=75649dfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75649dfe",
  null
  
)

export default component.exports